import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 3800615A-AAC6-43C8-9ACD-F8C7A0910C07
 * name shape-plus-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shape-plus-outline.svg
 * tags
 * - Shape 
 */
export const ShapePlusOutlineIcon = createSvgIcon(<><path d="M11 11V2H2V11M4 9V4H9V9M20 6.5C20 7.9 18.9 9 17.5 9S15 7.9 15 6.5 16.11 4 17.5 4 20 5.11 20 6.5M6.5 14L2 22H11M7.58 20H5.42L6.5 18.08M22 6.5C22 4 20 2 17.5 2S13 4 13 6.5 15 11 17.5 11 22 9 22 6.5M19 17V14H17V17H14V19H17V22H19V19H22V17Z" /></>, 'ShapePlusOutlineIcon');
export default ShapePlusOutlineIcon